module.exports = __webpack_public_path__ + "static/img/serverShop2.29d93b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/serverShop2.png
// module id = Nc+b
// module chunks = 0